import { Icon, Spinner } from "@fidelix/fx-miranda";
import { Button } from "react-aria-components";
import { styled } from "styled-components";
import { useHistoryReplayContext } from "./history-replay-context";

export function HistoryReplayPlayButton() {
  const { togglePlayMode, isPlaying, isLoading } = useHistoryReplayContext();

  return (
    <Container>
      <PlayButton isDisabled={isLoading} onPress={() => togglePlayMode()}>
        {isLoading ? (
          <Spinner size="small" />
        ) : (
          <Icon
            icon={isPlaying ? "pauseCircle" : "playCircle"}
            color="white"
            size={24}
          />
        )}
      </PlayButton>
    </Container>
  );
}
const Container = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  margin-top: ${(p) => p.theme.space("xsmall")};
  width: 50px;
`;
const PlayButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 30px;
  background: ${(p) => p.theme.colors.primary};
  &[data-disabled="true"] {
    background-color: ${(p) => p.theme.colors.lightNeutral};
    border-color: ${(p) => p.theme.colors.lightNeutral};
    color: white;
    cursor: not-allowed;
  }
  &[data-hovered="true"] {
    background-color: ${(p) => p.theme.colors.darkPrimary};
  }
`;
